module.exports = __webpack_public_path__ + "static/media/pic_with_alpha.57cf9a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/pic_with_alpha.png
// module id = 293
// module chunks = 0